import { FormProvider, useForm } from 'react-hook-form'
import { useEffect, useRef } from 'react'
import { DicomTagMetadata } from '@common/config/api/client'
import { SPACING } from '@common/theme/spacing'
import { Breadcrumb } from '@common/components/Breadcrumb'
import { TAG_DIED_MANAGEMENT_BREADCRUMB_ITEMS } from '../constants'
import { PageHeader } from '@common/components/PageHeader'
import { Grid2 as Grid, Stack } from '@mui/material'
import { SIZING } from '@common/theme/sizing'
import TagDeidManagementTable from './TagDeidManagementTable'
import { useGetAllDicomTagDeid } from '../hooks/useTagDeidQueries'
import { DicomTagsDeidValues } from '../types'

export default function TagDeidManagement() {
  const { data: fetchedTags, error } = useGetAllDicomTagDeid()
  const initialTags = useRef<DicomTagMetadata[]>([])

  const methods = useForm<DicomTagsDeidValues>({
    defaultValues: {
      tags: fetchedTags ?? [],
    },
  })

  useEffect(() => {
    if (fetchedTags) {
      initialTags.current = fetchedTags
      methods.reset({ tags: fetchedTags })
    }
  }, [fetchedTags, methods.reset])

  return (
    <FormProvider {...methods}>
      <Breadcrumb items={TAG_DIED_MANAGEMENT_BREADCRUMB_ITEMS} sx={{ marginBottom: SPACING.breadcrumbsMarginBottom }} />
      <Grid container>
        <Grid size={SIZING.gridSizeXxl}>
          <Stack spacing={SPACING.sectionsSpacing}>
            <PageHeader title="Modified Tags" />
            <TagDeidManagementTable error={error} />
          </Stack>
        </Grid>
      </Grid>
    </FormProvider>
  )
}
